module.exports = __webpack_public_path__ + "img/02_1_4_2.96e9f50c.png";